import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 274.17 199.89' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M110 0v55H55v55H0v82.09h15.85v7.82H28v-7.82h108.17v7.82h12.16v-7.82h15.85v-55h55v-55h27v7.82h12.16v-7.82h15.85V0zm101.2 74.09h-15.13V63h15.11zm-55 55h-15.12V118h15.11zM63 118h15.09v11.11H63zm23.11 0H89v11.11h-2.91zm7.89 0h4.1v11.11H94zm9.12 0h13v11.11h-13zm18 0h4.12v11.11h-4.12zm9.12 0h2.88v11.11h-2.92zM118 63h15.11v11.09H118zm23.11 0H144v11.09h-2.88zm39.11-8h-22.13V8h30v47h-7.88zm0 8v11.09h-4.12V63zm-27.11-8H149V8h4.12zM149 63h4.12v11.09H149zm9.12 0h13v11.09h-13zm18 19.11h4.12v47h-4.12zM185.19 63h2.88v11.09h-2.88zM118 8h26v47h-26zm-8 55v19.09h15.85v7.82h7.25V110h-30V63zm-11.9 0v47H94V63zM63 63h26v47H63zM8 184.07V118h26v66.09zm31 0V118h4.12v66.09zm9.12 0V118H55v19.11h15.84v7.82h7.25v39.17zm38 0v-47h30v47zm35 0v-47h4.12v47zm35.11 0h-26v-47h26zM141.08 110V82.09h30v47h-6.88V110zm70.09 19.11h-26v-47h26zm8-55V55h-23.1V8h30v66.09zm11.88 0V8h4.12v66.09zm35.11 0h-26V8h26z'
        />
        <path className='cls-1' d='M191.16 137.08h12.16v7.82h-12.16z' />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/TransenneIcon.js